import styled from '@emotion/styled';

import {
  blueBlack400,
  blueBlack630,
  blueUltramarine350,
  greyLight400,
} from '../../../../theme/videa-style-tokens';

export const ImagesArea = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-wrap: wrap;
  background-color: white;
`;

export const InsField = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 1em;
  position: relative;

  .generating {
    position: absolute;
    top: 5em;
    left: 9em;
    width: 20em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.5em;
    font-weight: 600;
    color: ${blueUltramarine350};
  }
`;

export const InsClinicalNotesTextArea = styled.textarea`
  font-size: 1em;
  font-family: 'proxima-nova', sans-serif;
  padding: 0.5em;
  border: 1px solid ${greyLight400};
  border-radius: 0.5em;
  width: 20em;
  height: 10em;
`;

export const InsFormLabel = styled.label`
  display: flex;
  font-family: 'proxima-nova', sans-serif;
  font-size: 1.125em;
  font-weight: 400;
  letter-spacing: -0.04em;
  line-height: 1;
  color: ${blueBlack630};
  width: 9em;
  margin-bottom: 0.125em;
  flex-direction: column;
  cursor: pointer;

  .videa-gpt {
    margin-top: 0.5em;
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 0.25em;
    font-weight: 600;
    padding: 0.25em 0.375em;
    border: 1px solid ${blueBlack400};
    color: ${blueBlack400};
    border-radius: 0.25em;
    width: fit-content;
    font-size: 0.75em;

    .MuiSvgIcon-root {
      font-size: 1.4em;
    }
  }

  .info-icon {
    height: 1em;
    width: 1em;
  }
`;

export const FindingTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 1em;

  .finding-table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    margin-bottom: 1em;
    height: fit-content;
  }

  tbody {
    vertical-align: top;
  }

  th,
  td {
    border-bottom: 1px solid ${blueBlack400};
    padding: 0.5em;
    text-align: center;
    text-align: left;
    font-family: monospace;
  }

  th {
    border-bottom: 1px solid ${blueBlack400};
    font-weight: 500;
    text-transform: uppercase;
    text-align: left;
  }
  .image-head {
    text-transform: uppercase;
    border-bottom: none;
    color: ${blueBlack630};
    max-width: 8ch;
    vertical-align: top;
  }
  .image-head-value {
    text-transform: uppercase;
    vertical-align: top;
    &.page {
      width: 3ch;
      text-align: right;
    }
    &.teeth-numbers {
      width: 36ch;
    }
  }
  .image-logo-head {
    border-bottom: 1px solid ${blueBlack400};

    .videa-logo {
      width: 113px;
      height: 50px;
    }
  }
  .finding-head {
    font-size: 1em;
    color: ${blueBlack630};
    padding: 0.5em;
    border-bottom: none;
    font-weight: bold;
  }
  .finding-tooth-identifier {
    width: 5ch;
  }
  .rbl-mesial,
  .rbl-distal {
    width: 5ch;
  }
`;

export const SummaryPage = styled.div`
  padding: 2em;
  width: 100%;

  .thumbnail-narrative {
    padding: 1em;
    margin-bottom: 2em;
    min-height: 5em;
  }

  .thumbnail-narrative-text {
    font-family: monospace;
    font-size: 1em;
    color: black;
    height: fit-content;
    width: 100%;
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;
    white-space: pre-line;
  }

  .thumbnail-narrative-title {
    font-family: monospace;
    font-size: 0.875em;
    color: black;
    height: fit-content;
    width: 100%;
    font-weight: 700;
    text-transform: uppercase;
    padding-bottom: 0.5em;
  }

  .section {
    margin: 1em 0;
  }

  .columns {
    display: flex;
    flex-wrap: nowrap;
    gap: 2em;

    .finding-table {
      height: fit-content;
    }
  }
`;

export const SummaryContent = styled.div`
  padding: 1em;
  border: 1px solid ${blueBlack400};
  width: 50em;
  section {
    margin-bottom: 1em;
  }
  h2 {
    margin: 0;
    font-weight: 400;
    font-size: 1.125em;
    font-family: 'Neue Haas Grotesk Display Pro', sans-serif;
    margin-bottom: 0.5em;
  }
  p {
    font-family: 'proxima-nova', sans-serif;
    font-size: 0.875em;
    margin: 0;
    line-height: 1em;
  }
  img {
    display: block;
    max-width: 100%;
    margin: 0 auto;
  }
`;

export const ImageSet = styled.div`
  width: 100%;
  min-height: 20em;
  border-radius: 0.5em;
  display: flex;
  flex-direction: column;
  gap: 1em;
  background-color: white;
  position: relative;

  .jpg-wrapper {
    background-color: white;
  }

  .thumbnail-narrative {
    border: 1px solid #ccc;
    padding: 1em;
    margin-bottom: 2em;
  }

  .thumbnail-narrative-text {
    font-family: monospace;
    font-size: 1em;
    color: black;
    height: fit-content;
    width: 100%;
  }

  .thumbnail-narrative-title {
    font-family: monospace;
    font-size: 0.875em;
    color: black;
    height: fit-content;
    width: 100%;
    font-weight: 700;
    text-transform: uppercase;
    padding-bottom: 0.5em;
  }

  .thumbnail-set-section {
    display: flex;
    gap: 1em;
    flex-direction: row;
  }

  .thumbnail-group-title {
    font-family: monospace;
  }

  .thumbnail-image-section {
    display: flex;
    gap: 1em;
  }

  .thumbnail-group {
    display: flex;
    width: 20em;
    flex-direction: column;
    gap: 0.5em;
  }

  .image-block {
    display: flex;
    gap: 1em;
    flex-direction: row;
  }
`;

export const ImageSection = styled.div`
  display: flex;
  gap: 1em;
  flex-direction: column;
  width: 100%;

  .thumbnail-analysis-section {
    width: 100%;
  }
`;

export const ImageTitle = styled.div`
  font-size: 1.125em;
  color: ${blueBlack630};
  font-weight: 500;
  text-transform: uppercase;
  margin-top: 0.5em;
  width: 100%;
`;
